module.exports = __webpack_public_path__ + "img/hipline_small.ffcf74e3.png";